export const themeManager = {
  applyTheme: (theme) => {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);

    localStorage.setItem('preferred-theme', theme);
  },

  getCurrentTheme: () => {
    return localStorage.getItem('preferred-theme') || 'light';
  },

  initializeTheme: () => {
    const savedTheme = themeManager.getCurrentTheme();
    themeManager.applyTheme(savedTheme);
    return savedTheme;
  },

  toggleTheme: (currentTheme) => {
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    themeManager.applyTheme(newTheme);
    return newTheme;
  }
};
